import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  belongs_to: "Api", // Default value
  active_project: null,
  active_collection: null, // collection ID
  active_folder_id: null, // subfolder ID
  active_subfolder_id: null,
  active_auth: null,
  folder_name: "",
  api_screen: false,
  api_url: null,
  environment_id: null,
  request_id: null, //request id
  request_body: null,
  full_path: null,
  script:null,  //storing scripts for  collection 
  folder_script: null, //string scripts for folde/subfolder
  // hasUnsavedChanges: false,
  previousState: null,
  project_level:null, //it is use to know that the folder is a collection, folder,sub_folder
  collection_request_script: null, // to indicate collection request script
  folder_request_script: null, // to indivate folder request script
  sub_folder_request_script: null // to indicate subfolder request script
};

const metaDataSlice = createSlice({
  name: "metaData",
  initialState,
  reducers: {
    setMetaData: (state, action) => {
      Object.assign(state, action.payload); 
    },
    resetMetaData: () => initialState,
    // updateField: (state, action) => {
    //   const { field, value } = action.payload; 
    //   state[field] = value;
    // },
    updateMetaData: (state, action) => {
      return {
        ...state,
        ...action.payload,
        request_body: {
          ...(state.request_body || {}),
          ...(action.payload.request_body || {})
        }
      };
    },
    // setUnsavedChanges: (state, action) => {
    //   state.hasUnsavedChanges = action.payload;
    // },
    setPreviousState: (state) => {
      state.previousState = { ...state };
    },
    revertChanges: (state) => {
      if (state.previousState) {
        return JSON.parse(JSON.stringify(state.previousState));
      }
      return state;
    }
  },
});

export const { setMetaData, resetMetaData, updateField,updateMetaData, setUnsavedChanges, setPreviousState, revertChanges } =
  metaDataSlice.actions;
export default metaDataSlice.reducer;
